var map = {
	"./EFOSuploads/EFOSuploads.module": [
		"./src/app/EFOSuploads/EFOSuploads.module.ts",
		"common",
		"EFOSuploads.module"
	],
	"./account-statement/account-statement.module": [
		"./src/app/account-statement/account-statement.module.ts",
		"common",
		"account-statement.module"
	],
	"./accounting/accounting.module": [
		"./src/app/accounting/accounting.module.ts",
		"accounting.module"
	],
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"authentication.module"
	],
	"./connection-foreign/connection-foreign.module": [
		"./src/app/connection-foreign/connection-foreign.module.ts",
		"connection-foreign.module"
	],
	"./conta-e-fiscal/conta-e-fiscal.module": [
		"./src/app/conta-e-fiscal/conta-e-fiscal.module.ts",
		"common",
		"conta-e-fiscal.module"
	],
	"./documents/documents.module": [
		"./src/app/documents/documents.module.ts",
		"common",
		"documents.module"
	],
	"./indicators/indicators.module": [
		"./src/app/indicators/indicators.module.ts",
		"common",
		"indicators.module"
	],
	"./kardex/kardex.module": [
		"./src/app/kardex/kardex.module.ts",
		"common",
		"kardex.module"
	],
	"./log/log.module": [
		"./src/app/log/log.module.ts",
		"log.module"
	],
	"./mail-recepcion/mail-recepcion.module": [
		"./src/app/mail-recepcion/mail-recepcion.module.ts",
		"common",
		"mail-recepcion.module"
	],
	"./pagos-ppd/pagos-ppd.module": [
		"./src/app/pagos-ppd/pagos-ppd.module.ts",
		"common",
		"pagos-ppd.module"
	],
	"./pagos-pue/pagos-pue.module": [
		"./src/app/pagos-pue/pagos-pue.module.ts",
		"common",
		"pagos-pue.module"
	],
	"./papers/papers.module": [
		"./src/app/papers/papers.module.ts",
		"common",
		"papers.module"
	],
	"./partners/partners.module": [
		"./src/app/partners/partners.module.ts",
		"common",
		"partners.module"
	],
	"./payroll-layout/payroll-layout.module": [
		"./src/app/payroll-layout/payroll-layout.module.ts",
		"common",
		"payroll-layout.module"
	],
	"./payroll/payroll.module": [
		"./src/app/payroll/payroll.module.ts",
		"common",
		"payroll.module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"common",
		"reports.module"
	],
	"./repositories/repositories.module": [
		"./src/app/repositories/repositories.module.ts",
		"repositories.module"
	],
	"./sap-documents/sap-documents.module": [
		"./src/app/sap-documents/sap-documents.module.ts",
		"common",
		"sap-documents.module"
	],
	"./sat-downloads/sat-downloads.module": [
		"./src/app/sat-downloads/sat-downloads.module.ts",
		"common",
		"sat-downloads.module"
	],
	"./settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"common",
		"settings.module"
	],
	"./starter/starter.module": [
		"./src/app/starter/starter.module.ts",
		"starter.module"
	],
	"./suppliers/suppliers.module": [
		"./src/app/suppliers/suppliers.module.ts",
		"common",
		"suppliers.module"
	],
	"./sync-log/sync-log.module": [
		"./src/app/sync-log/sync-log.module.ts",
		"common",
		"sync-log.module"
	],
	"./sync-reconciliation-monitor/sync-reconciliation-monitor.module": [
		"./src/app/sync-reconciliation-monitor/sync-reconciliation-monitor.module.ts",
		"common",
		"sync-reconciliation-monitor.module"
	],
	"./uploads/uploads.module": [
		"./src/app/uploads/uploads.module.ts",
		"common",
		"uploads.module"
	],
	"./vault-history/vault-history.module": [
		"./src/app/vault-history/vault-history.module.ts",
		"common",
		"vault-history.module"
	],
	"./vault-sat/vault-sat.module": [
		"./src/app/vault-sat/vault-sat.module.ts",
		"common",
		"vault-sat.module"
	],
	"./vault/vault.module": [
		"./src/app/vault/vault.module.ts",
		"common",
		"vault.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main